import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Header = ({ lang, setLang, t }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,backdrop-filter,border-color,padding] duration-500 ${
        scrolled
          ? "bg-[#FAFAF7]/80 backdrop-blur-xl backdrop-saturate-150 border-b border-[#E6E3DC]/80 py-4"
          : "bg-transparent border-b border-transparent py-6"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className={`font-serif-display text-xl md:text-2xl tracking-tight transition-colors duration-500 ${
            scrolled ? "text-[#171B26]" : "text-[#F6F5F1]"
          }`}
        >
          Whitlock<span className="text-[#B0863A]">16</span>
        </a>

        <div className="flex items-center gap-6 md:gap-8">
          <div
            className={`flex items-center rounded-full p-0.5 border transition-colors duration-500 ${
              scrolled ? "border-[#E6E3DC]" : "border-white/40"
            }`}
            data-testid="language-switcher"
          >
            {["fr", "en"].map((code) => (
              <button
                key={code}
                onClick={() => setLang(code)}
                data-testid={`lang-${code}`}
                className="relative px-3.5 py-1.5 text-xs font-semibold uppercase tracking-widest rounded-full"
              >
                <AnimatePresence>
                  {lang === code && (
                    <motion.span
                      layoutId="lang-pill"
                      className="absolute inset-0 rounded-full bg-[#B0863A]"
                      transition={{ type: "spring", stiffness: 400, damping: 32 }}
                    />
                  )}
                </AnimatePresence>
                <span
                  className={`relative z-10 transition-colors duration-300 ${
                    lang === code
                      ? "text-[#FAFAF7]"
                      : scrolled
                      ? "text-[#7A8091]"
                      : "text-[#F6F5F1]/80"
                  }`}
                >
                  {code}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </motion.header>
  );
};
